// Packages
import moment from 'moment';
import { titleCase } from './titleCase';

function parsePersonalPhrase() {
  const user = JSON.parse(localStorage.getItem('updateUser'));
  const map = {
    morning: `Good Morning, ${titleCase(user.first_name)}`,
    afternoon: `Good Afternoon, ${titleCase(user.first_name)}`,
    evening: `Good Evening, ${titleCase(user.first_name)}`,
    night: `Goodnight, ${titleCase(user.first_name)}`,
  };

  if ( moment().hour() >= 4 && moment().hour() < 12 ) {
    return map.morning;
  }

  if ( moment().hour() >= 12 && moment().hour() < 18 ) {
    return map.afternoon;
  }

  if ( moment().hour() >= 18 && moment().hour() <= 23 ) {
    return map.evening;
  }

  if ( moment().hour() >= 0 && moment().hour() < 4 ) {
    return map.night;
  }
}


export {
  parsePersonalPhrase,
};



// WEBPACK FOOTER //
// ./client/utils/personalPhrases.js